import { render, staticRenderFns } from "./delivery-email.vue?vue&type=template&id=5a5a09a2"
import script from "./delivery-email.vue?vue&type=script&lang=js"
export * from "./delivery-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports